export default {"src":"/_next/static/media/unhide-small-icon.e18b35f2.svg","height":8,"width":14};